/// <amd-module name="Feed/Common/Types/IFeedMessage" />
export enum MessageState {
    None,
    EmptyFeed,
    EmptyView,
    EmptyCache,
    EmptyFilter,
    EmptySource,
    DeletedFeed
}
